import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableDebeFormGroup = ({ iError, iTouched, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    (salida) => {
      setFieldValue('cuentaContableDebe', salida.value)
      setFieldValue('cuentaContableDebeInfo', salida.label)
      KeyEventUtil.leaveOnKeyEvent('select-cuentaContableHaber')
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableDebe', '')
    setFieldValue('cuentaContableDebeInfo', '')
    KeyEventUtil.leaveOnKeyEvent('select-cuentaContableDebe')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='CC DEBE' htmlFor='select-cuentaContableDebe'  md={4} alignRightAt='md'/>
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableDebe' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContableDebe' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableDebeFormGroup)
